import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute: React.FC = () => {
  const isAuthenticated = Boolean(localStorage.getItem("user"));

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  try {
    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    if (userData.userType !== "PATIENT") {
      localStorage.removeItem("user");
      return <Navigate to="/login" replace />;
    }
  } catch (error) {
    localStorage.removeItem("user");
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
